(function () {
  'use strict';

  function init(root) {
    if (root.dataset.grReady === '1') return;
    root.dataset.grReady = '1';

    var track = root.querySelector('[data-gr-track]');
    var prev = root.querySelector('[data-gr-prev]');
    var next = root.querySelector('[data-gr-next]');
    if (!track) return;

    var loop = root.hasAttribute('data-gr-loop');
    var originals = Array.prototype.slice.call(track.querySelectorAll('.gr__card'));
    var firstMid = originals[0] || null;
    var firstBefore = null;
    var looped = false;
    var settleTimer = null;

    function isRtl() {
      return getComputedStyle(track).direction === 'rtl';
    }

    function forward() {
      return isRtl() ? -1 : 1;
    }

    function step() {
      var card = track.querySelector('.gr__card');
      if (!card) return track.clientWidth;
      var styles = getComputedStyle(track);
      var gap = parseFloat(styles.columnGap || styles.gap || '0') || 0;
      return card.getBoundingClientRect().width + gap;
    }

    function overflowing() {
      return track.scrollWidth > track.clientWidth + 1;
    }

    function makeClone(card) {
      var c = card.cloneNode(true);
      c.setAttribute('aria-hidden', 'true');
      c.setAttribute('data-gr-clone', '');
      c.querySelectorAll('a, button, [tabindex]').forEach(function (el) {
        el.setAttribute('tabindex', '-1');
      });
      return c;
    }

    function setWidth() {
      if (!firstBefore || !firstMid) return 0;
      return Math.abs(firstMid.getBoundingClientRect().left - firstBefore.getBoundingClientRect().left);
    }

    function offsetInMid() {
      var t = track.getBoundingClientRect();
      var m = firstMid.getBoundingClientRect();
      return isRtl() ? m.right - t.right : t.left - m.left;
    }

    function jump(amount) {
      var snap = track.style.scrollSnapType;
      track.style.scrollSnapType = 'none';
      track.scrollBy({ left: amount * forward(), behavior: 'instant' });
      track.style.scrollSnapType = snap;
    }

    function settle() {
      if (!looped) return;
      var w = setWidth();
      if (!w) return;
      var d = offsetInMid();
      if (d < -1) jump(w);
      else if (d >= w - 1) jump(-w);
    }

    function buildLoop() {
      if (!loop || looped || originals.length < 2 || !overflowing()) return;
      var before = document.createDocumentFragment();
      var after = document.createDocumentFragment();
      originals.forEach(function (card) {
        before.appendChild(makeClone(card));
        after.appendChild(makeClone(card));
      });
      firstBefore = before.firstChild;
      track.insertBefore(before, track.firstChild);
      track.appendChild(after);
      looped = true;
      jump(setWidth());
    }

    function go(dir) {
      if (looped) settle();
      track.scrollBy({ left: step() * dir * forward(), behavior: 'smooth' });
    }

    function setDisabled(btn, off) {
      if (!btn) return;
      btn.classList.toggle('swiper-button-disabled', off);
      btn.setAttribute('aria-disabled', off ? 'true' : 'false');
      btn.tabIndex = off ? -1 : 0;
    }

    function sync() {
      var over = overflowing();
      [prev, next].forEach(function (btn) {
        if (btn) btn.classList.toggle('swiper-button-lock', !over);
      });
      if (looped) {
        setDisabled(prev, false);
        setDisabled(next, false);
        return;
      }
      var max = track.scrollWidth - track.clientWidth - 1;
      var pos = Math.abs(track.scrollLeft);
      setDisabled(prev, pos <= 1);
      setDisabled(next, pos >= max);
    }

    function onScroll() {
      sync();
      if (!looped) return;
      clearTimeout(settleTimer);
      settleTimer = setTimeout(settle, 140);
    }

    function bind(btn, dir) {
      if (!btn) return;
      btn.addEventListener('click', function () { go(dir); });
      btn.addEventListener('keydown', function (e) {
        if (e.key === 'Enter' || e.key === ' ') {
          e.preventDefault();
          go(dir);
        }
      });
    }

    bind(prev, -1);
    bind(next, 1);

    root.addEventListener('click', function (e) {
      var more = e.target.closest('[data-gr-more]');
      if (!more || !root.contains(more)) return;
      var card = more.closest('.gr__card');
      var shortEl = card.querySelector('[data-gr-short]');
      var fullEl = card.querySelector('[data-gr-full]');
      var open = more.getAttribute('aria-expanded') === 'true';
      if (shortEl) shortEl.hidden = !open;
      if (fullEl) fullEl.hidden = open;
      more.setAttribute('aria-expanded', open ? 'false' : 'true');
      more.textContent = open ? more.dataset.more : more.dataset.less;
    });

    function measure() {
      root.querySelectorAll('[data-gr-short]').forEach(function (el) {
        var card = el.closest('.gr__card');
        var more = card && card.querySelector('[data-gr-more]');
        if (!more || more.getAttribute('aria-expanded') === 'true') return;
        var cut = el.hasAttribute('data-gr-cut') || el.scrollHeight > el.clientHeight + 1;
        more.hidden = !cut;
      });
    }

    track.addEventListener('scroll', onScroll, { passive: true });
    if ('onscrollend' in window) track.addEventListener('scrollend', settle);
    window.addEventListener('resize', function () {
      buildLoop();
      settle();
      sync();
      measure();
    });
    if (document.fonts && document.fonts.ready) document.fonts.ready.then(measure);

    measure();
    buildLoop();
    sync();
  }

  function boot(scope) {
    (scope || document).querySelectorAll('[data-gr]').forEach(init);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', function () { boot(); });
  } else {
    boot();
  }

  document.addEventListener('shopify:section:load', function (e) {
    boot(e.target);
  });
})();
